import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {RepositoryMilestoneNewPageQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryMilestoneNewPageQuery'

import {issuesAppBuilder} from '../config/app-builder'

// RepositoryDataResponse exposes the errors array so handleRepositoryDataError can detect FORBIDDEN/SAML.
export type MilestoneNewPayload = RepositoryDataResponse<RepositoryMilestoneNewPageQueryQuery>

export function buildMilestoneNewRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  // The backend milestone_new_handler resolves the persisted RepositoryMilestoneNewPageQuery
  // server-side, so the route only needs the default pathname fetch.
  return appBuilder.createQueryRouteConfig('milestoneNewRoute', {
    path: '/:owner/:repo/milestones/new',
    queries: [mainQuery<MilestoneNewPayload>()],
  })
}

export const milestoneNewRoute = buildMilestoneNewRoute(issuesAppBuilder)
